import TourGamesPicksForm from './TourGamesPicksForm';
export default TourGamesPicksForm